module.exports = __webpack_public_path__ + "c8ec4733226df38a6c0bf69195668c8f.svg";